import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PRODUCT_LIST_NAMESPACE } from '@epicuro-next/constants/rule-engine/product-list-rules';
import { DataShareLinkModule } from '@epicuro-next/data/share-link';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { PlatformTargetModule } from '@epicuro-next/platform/target';

import { ShareableListDirective } from './directives';

@NgModule({
  imports: [
    CommonModule,
    ClipboardModule,
    PlatformTargetModule,
    RouterModule,
    ConfigurationModule.forFeature([PRODUCT_LIST_NAMESPACE]),
    DataShareLinkModule,
  ],
  exports: [ShareableListDirective],
  declarations: [ShareableListDirective],
})
export class ShareableListModule {}
